<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Bienvenido</h4>
    </div>
    <div class="card-content">
      <div class="row">
        <div class="col-md-12">
          <h5>Declaración Patrimonial</h5>
        </div>
        <div class="col-md-12" v-if="this.getKey('status_dec') == 0">
          <div class="alert alert-info">
            <span>No tienes declaraciones pendientes</span>
          </div>
          <div class="alert alert-info" role="alert" v-if="this.getKey('status_dec') == 0">
            ¿Tienes alguna aclaración que hacer sobre tu declaracion patrimonial?, <a href="javascript:void(0)" class="alert-link" @click="aclaraciones"> agrégala aquí.</a>
          </div>
          <div class="alert alert-warning" role="alert" v-if="!hasfiscal">
            Si omitiste anexar el acuse de presentación de la declaración fiscal, <a href="javascript:void(0)" class="alert-link" @click="fiscal"> agrégalo aquí.</a>
          </div>
          <div class="text-center">
            <button class="btn btn-success" @click="irHistorico">Consultar Historial</button>
          </div>
          <div class="text-center">
            <!-- Button trigger modal -->
            <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong">
              Consulta el aviso de privacidad
            </button>
          </div>
          <div>
            <!-- Modal -->
            <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">AVISO DE PRIVACIDAD SIMPLIFICADO </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <p style="text-align:right"><b>CONTRALORIA MUNICIPAL DE IRAPUATO
                      </b></p>
                    <p style="text-align:center"><b>
                        AVISO DE PRIVACIDAD SIMPLIFICADO
                        <br>DECLARACIONES PATRIMONIALES
                      </b></p>
                    <p><b>
                        I. Denominación y domicilio del responsable.
                      </b></p>
                    <p style="text-align:justify">
                      La <strong>Dirección de Auditoría</strong>, dependiente de la Contraloría Municipal de Irapuato, Guanajuato, con domicilio ubicado en Avenida 
                      Álvaro Obregón no. 100, 4to piso Zona Centro, C.P. 36500 en el municipio de Irapuato Guanajuato, es la <strong>Responsable</strong> del tratamiento 
                      y resguardo de los datos personales que nos proporcione, siendo el <strong>Sujeto Obligado</strong> el Municipio de Irapuato, Guanajuato, los cuales 
                      serán protegidos conforme a lo dispuesto por la Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados y la 
                      Ley de Protección de Datos Personales en Posesión de Sujetos Obligados para el Estado de Guanajuato.
                    </p>
                    <p><b>
                        II. Finalidad del tratamiento de los datos personales.
                      </b></p>
                    <p style="text-align:justify">
                      Los datos personales solicitados anteriormente, serán utilizados para:
                      <ul style="padding: 1rem;">
                        <li>Generar en el sistema DECLARANET IRAPUATO el alta de la persona servidora pública.</li>
                        <li>Integrar la información correspondiente a declaraciones patrimoniales y de intereses del personal 
                          que labora en la Administración Pública Municipal centralizada y descentralizada.</li>
                        <li>Cumplir con las obligaciones de transparencia, en específico lo relacionado con las declaraciones 
                          patrimoniales.</li>
                        <li>Dar seguimiento a la presentación de la declaración patrimonial y de intereses, para la detección 
                          e los servidores públicos que omitieron presentarla.</li>
                        <li>Verificar de manera aleatoria el contenido de las declaraciones patrimoniales, de conflicto de 
                          intereses y constancias de presentación de declaración fiscal de las personas servidores públicas, 
                          que obren en el sistema declaración patrimonial, así como de la evolución del patrimonio de los 
                          servidores públicos.</li>
                      </ul>
                    </p>
                    <p><b>
                        III. Transferencia de datos personales.
                      </b></p>
                    <p style="text-align:justify">
                      Se informa que no se realizarán transferencias de datos personales, salvo aquéllas que sean necesarias para atender 
                      requerimientos de información de una autoridad competente, que estén debidamente fundados y motivados, ni tampoco se 
                      realizarán transferencias adicionales, salvo que se actualice alguno de los casos establecidos en el artículo 19 de 
                      la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados para el Estado de Guanajuato.
                    </p>
                    <p><b>
                        IV. Negativa para el tratamiento de sus datos personales.
                      </b></p>
                    <p style="text-align:justify">
                      Podrá manifestar la negativa del tratamiento de sus datos personales para finalidades y transferencias de los datos que 
                      requieren el consentimiento del titular directamente en las instalaciones de la Unidad de Transparencia del <strong>Sujeto Obligado</strong>, 
                      siendo este el municipio de Irapuato, Guanajuato, con domicilio ubicado en Calle Hidalgo No.77 Barrio de Santiaguito, 
                      Zona Centro, C.P. 36500, en el municipio de Irapuato, Guanajuato, (CAM) o bien, comunicarse al número telefónico 
                      462 6069 999 extensión 1431, de lunes a viernes en un horario de 08:30 a 16:00 horas, así como a través del correo electrónico: 
                      <strong>transparencia.irapuato@irapuato.gob.mx</strong>.
                    </p>
                    <p><b>
                        Cabe mencionar que el no compartir datos, no impide recibir el servicio.
                      </b></p>
                    <p style="text-align:right">
                      <b>
                        Fecha de elaboración
                      </b><br>
                      17 de febrero de 2025
                    </p>
                    <p style="text-align:right">
                      <b>
                        Última actualización del aviso de privacidad.
                      </b><br>
                      12 de marzo de 2026.
                    </p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="this.getKey('status_dec') == 1">
          <div class="alert alert-warning" v-for="(dec,i) in this.getKey('tipo_dec_list')" :key="i">
            <!-- <span>Tienes una declaración {{this.getKey('tipo_dec')}} pendiente</span> -->
            <span> Tienes una declaración <b>{{tipoD(dec.tipo_dec_id)}}</b> pendiente del <b>{{dec.periodo}}</b> en <b>{{getDep(dec.ente_publico_id)}}</b></span>
            <!-- <span v-if="this.getKey('tipo_dec_list').length == 1">Tienes una declaración {{this.getKey('tipo_dec')}} pendiente</span> -->
            <!-- <span v-else>Debes presentar una declaración {{this.getKey('tipo_dec')}} y posteriormente una Final</span> -->
          </div>
          <div class="text-center">
            <button class="btn btn-success btn-wd" @click="irLlenado">Ir a llenado</button>
          </div>
        </div>
        <div class="col-md-12" v-if="false">
          <div class="alert alert-danger">
            <span>La fecha limíte para presentar tu declaración ha expirado</span>
          </div>
          <div class="text-center">
            <button class="btn btn-success btn-wd">Solicitar prórroga</button>
          </div>
        </div>
      </div>

      <br>
      <br>

    </div>
  </div>
</template>
<script>
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
  import chartist_tooltip from 'chartist-plugin-tooltips';

  export default {
    components: {
      StatsCard,
      ChartCard,
      CircleChartCard
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        $Chartist: null,
        obligados: '',
        min: 0,
        max: 0,
        faltantes: '',
        porcentaje: 0,
        declaraciones: '',
        plugins: null,
        hasfiscal: false,
        dependencias_: []
      }
    },
    methods: {
      tipoD(tipo) {
        switch (tipo) {
          case 1:
            return 'Inicial'
          case 2:
            return 'Anual'
          case 3:
            return 'Final'
        }
      },
      getDep(id) {
        let dep = this.dependencias_.find(m => m.id == id);
        if (dep) {
          return dep.valor;
        }
        return '';
      },
      irLlenado() {
        this.$router.push('/forms/infPersonal');
      },
      fiscal() {
        //this.$router.push('/forms/fiscal');
        this.$router.push('fiscal');

      },
      aclaraciones() {
        this.$router.push('/forms/aclaraciones');
      },
      irHistorico() {
        this.$router.push('/forms/historico');
      }

    },
    created() {
      if (!(this.getKey('status_dec')) == 1) {
        localStorage.setItem('std', 0);
      }

      this.$http.get("hasfiscal/" + this.getKey('uid')).then(
        response => {
          if (response.data.files) {
            this.hasfiscal = true;
          }
        },
        error => {
          this.Err(error);
        }
      );

      this.$http.get("cat/dec").then(
        response => {
          this.dependencias_ = response.data.entes_publicos;
        },
        error => {
          this.Err(error);
        }
      );
    },

  }

</script>
<style>
  .chartist-tooltip {
    position: absolute !important;
    background: rgba(0, 0, 0, 0.6) !important;
    color: white !important;
    padding: 0px 10px !important;
    border-radius: 5px !important;
  }

  .titulos {
    text-align: left !important;
  }

  .modal-backdrop {
    z-index: 1040 !important;
  }

  .modal-content {
    margin: 2px auto;
    z-index: 1100 !important;
  }

  .modal-backdrop {
    /* bug fix - no overlay */
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/TableroDec.vue